import { generatePath } from 'react-router-dom';

import { createRouteConfig } from 'modules/common/utils/createRouteConfig';

const ROOT_PATH = '/';
const ANALYTICS_PATH = `${ROOT_PATH}analytics`;

export const analyticsRoutesConfig = createRouteConfig(
  {
    analytics: {
      path: ANALYTICS_PATH,
      generatePath: () => generatePath(ANALYTICS_PATH),
    },
  },
  ROOT_PATH,
);
